/*
 * map.js — esbuild IIFE entry
 * ===========================
 * Replaces app/assets/javascripts/map.js (Sprockets //= require chain).
 *
 * Load order is critical: Leaflet core must set window.L before any plugin
 * attempts to extend it. Mapbox.js extends L after core is ready.
 *
 * This bundle is IIFE-formatted so all plugins see window.L immediately.
 */

// ── 1. Leaflet core ──────────────────────────────────────────────────────────
import L from 'leaflet';
window.L = L;

// ── 2. Leaflet plugins (extend window.L — must come after core) ───────────────
import 'leaflet.markercluster';
import 'leaflet-plugins/layer/tile/Bing';   // L.BingLayer
import 'leaflet-hash';                       // map.addHash()
import 'leaflet-spin';                       // map.spin()
import 'spin.js';
import 'leaflet.fullscreen';
// Explicit umd path: package.json "sideEffects" lists the umd build but not the
// esm build that node resolution picks by default. Without this, esbuild treats
// the bare import as side-effect-free and silently drops it.
import 'leaflet.locatecontrol/dist/L.Control.Locate.umd.js';
import 'leaflet-google-places-autocomplete'; // L.Control.GPlaceAutocomplete

// ── 3. Mapbox.js (extends L — must come after Leaflet core + plugins) ─────────
// mapbox.js v3 is a Leaflet plugin; it attaches L.mapbox to window.L
import 'mapbox.js';

// ── 4. App initialisation functions (exposed globally for inline view scripts) ─
(function ($) {
  // Read membership/trial from DOM — avoids globals set at load time
  function getUserMembership() {
    var $el = $('#user-options #current-company');
    return $el.length ? $el.data('membership') : 'visitor';
  }

  function getUserTrial() {
    var $el = $('#user-options #current-company');
    return $el.length ? $el.data('trial') : null;
  }

  // Shared tile layers + controls added to every map instance
  function _addLayersToMap(map) {
    var ggl_sat  = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',  { maxZoom: 19, subdomains: ['mt0','mt1','mt2','mt3'] });
    var ggl_hyb  = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{ maxZoom: 19, subdomains: ['mt0','mt1','mt2','mt3'] });
    var ggl_road = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',  { maxZoom: 19, subdomains: ['mt0','mt1','mt2','mt3'] });

    map.scrollWheelZoom.disable();

    var osm  = L.tileLayer('//a.tile.openstreetmap.org/{z}/{x}/{y}.png');

    var layers = {
      'Google (Road)': ggl_road,
      'Google (Sat)':  ggl_sat,
      'Google (Hyb)':  ggl_hyb,
      'OSM': osm
    };

    // Guard: BingLayer may not attach correctly in all bundle configurations
    if (typeof L.BingLayer === 'function') {
      layers['Bing'] = new L.BingLayer('AjPs_cxhvGXrP52k9XHY0wKbw0yfp1XV97JD89B1JLwsndt_7JUIhtH_kVa52mIk', { type: 'Aerial' });
    }

    // Guard: mapbox.js may not be available in all environments
    if (L.mapbox) {
      L.mapbox.accessToken = 'pk.eyJ1Ijoia2hlbGFsIiwiYSI6IjJUUkFjYTgifQ.RRczLTrCVpftSWDPiUGHTA';
      var mapbox_road  = L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v9');
      var mapbox_light = L.mapbox.styleLayer('mapbox://styles/mapbox/light-v9');
      var mapbox_sat   = L.mapbox.styleLayer('mapbox://styles/mapbox/satellite-streets-v9');
      map.addLayer(mapbox_light);
      layers['MB (light)'] = mapbox_light;
      layers['MB (road)']  = mapbox_road;
      layers['MB (sat)']   = mapbox_sat;
    } else {
      map.addLayer(osm);
    }

    map.addControl(new L.Control.Layers(layers, {}));
  }

  // Single-marker map used on company profile office cards
  window.singleLeafLetMapInit = function (selector, lat, lng) {
    if (lat == null || lng == null) { return false; }
    var map = L.map($(selector).exists()[0]).setView([lat, lng], 13);
    _addLayersToMap(map);
    L.marker([lat, lng]).addTo(map);
  };

  // Full cluster map used on company projects index and profile pages
  window.leafLetMapInit = function () {
    var initlatitude  = 39.91;
    var initlongitude = 116.38;
    var initZoom      = 2;

    // Leaflet 1.x resolves marker images via webpack/esbuild asset URLs automatically
    // — no need to set L.Icon.Default.imagePath manually when bundled via esbuild.

    window.map = L.map('map', {
      fullscreenControl: true,
      scrollWheelZoom:   false,
      keyboard:          false,
      fullscreenControlOptions: { position: 'topleft' }
    }).setView([initlatitude, initlongitude], initZoom);

    _addLayersToMap(window.map);

    window.map.addControl(new L.Control.GPlaceAutocomplete({
      callback: function (place) {
        var loc = place.geometry.location;
        var vp  = place.geometry.viewport;
        window.map.panTo([loc.lat(), loc.lng()]);
        window.map.fitBounds([
          [vp.getSouthWest().lat(), vp.getSouthWest().lng()],
          [vp.getNorthEast().lat(), vp.getNorthEast().lng()]
        ]);
      }
    }));

    // Find my location control — guard against plugin load failure
    if (L.control && typeof L.control.locate === 'function') {
      window.map.addControl(new L.control.locate({ position: 'topright' }));
    }

    // Marker cluster group — populated by MapLoader module
    window.markers = L.markerClusterGroup({
      spiderfyOnMaxZoom:         true,
      showCoverageOnHover:       false,
      zoomToBoundsOnClick:       true,
      maxClusterRadius:          60,
      removeOutsideVisibleBounds: true,
      disableClusteringAtZoom:   18,
      animate:                   false
    });

    window.map.on('zoomend',      function () { window.map.closePopup(); });
    window.markers.on('clusterclick', function () { window.map.closePopup(); });

    // Sync browser URL hash with map position (leaflet-hash)
    window.map.addHash();
  };

  // Expose membership helpers for any legacy inline scripts that read them
  window.getUserMembership = getUserMembership;
  window.getUserTrial      = getUserTrial;

}(window.$));
